import { faHome } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Breadcrumbs, Link, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router'
import { useLang } from '../../language'

import './BreadCrumbCustom.scss'

export const BreadCrumbCustom = ({ items, className }: any) => {

    const navigate = useNavigate()

    const Lang = useLang()

    return (
        <div className={`BreadCrumbCustom ${className ? className : ''}`}>
            <Breadcrumbs aria-label="breadcrumb">
                <Typography color="text.primary">
                    <FontAwesomeIcon icon={faHome} />
                </Typography>
                {/* <Typography color="text.primary">
                {Lang('MI_COLEGIO')}
                </Typography> */}
                {
                    items?.map((item: any, index: number) => {
                        return (
                            index !== (items.length - 1) ? (
                                <Link
                                    underline="hover"
                                    color="inherit"
                                    className='pointer'
                                    onClick={() => navigate(item.link)} key={index}
                                >
                                    {item.title}
                                </Link>
                            ) : (
                                <Typography color="text.primary" key={index}>{item.title}</Typography>
                            )
                        )
                    })
                }
            </Breadcrumbs>
        </div>
    )
}
